import type { CountryCode, Dog, RegistrationBreeder, RegistrationPerson } from '../types'

export const countries: readonly CountryCode[] = [
  'AF',
  'AX',
  'NL',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'AE',
  'AR',
  'AM',
  'AW',
  'AU',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BA',
  'BW',
  'BV',
  'BR',
  'IO',
  'VG',
  'BN',
  'BG',
  'BF',
  'BI',
  'KY',
  'CL',
  'CK',
  'CR',
  'CW',
  'DJ',
  'DM',
  'DO',
  'EC',
  'EG',
  'SV',
  'ER',
  'ES',
  'ZA',
  'GS',
  'KR',
  'SS',
  'ET',
  'FK',
  'FJ',
  'PH',
  'FO',
  'GA',
  'GM',
  'GE',
  'GH',
  'GI',
  'GD',
  'GL',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'HN',
  'HK',
  'SJ',
  'ID',
  'IN',
  'IQ',
  'IR',
  'IE',
  'IS',
  'GB',
  'IL',
  'IT',
  'TL',
  'AT',
  'JM',
  'JP',
  'YE',
  'JE',
  'JO',
  'CX',
  'KH',
  'CM',
  'CA',
  'CV',
  'BQ',
  'KZ',
  'KE',
  'CF',
  'CN',
  'KG',
  'KI',
  'CO',
  'KM',
  'CD',
  'CG',
  'CC',
  'GR',
  'HR',
  'CU',
  'KW',
  'CY',
  'LA',
  'LV',
  'LS',
  'LB',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'EH',
  'MO',
  'MG',
  'MW',
  'MV',
  'MY',
  'ML',
  'MT',
  'IM',
  'MA',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NI',
  'NE',
  'NG',
  'NU',
  'NF',
  'NO',
  'CI',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PN',
  'KP',
  'MK',
  'MP',
  'PT',
  'PR',
  'PL',
  'GQ',
  'QA',
  'FR',
  'TF',
  'GF',
  'PF',
  'RE',
  'RO',
  'RW',
  'SE',
  'SH',
  'KN',
  'LC',
  'VC',
  'BL',
  'MF',
  'PM',
  'DE',
  'SB',
  'ZM',
  'WS',
  'SM',
  'ST',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SX',
  'SK',
  'SI',
  'SO',
  'LK',
  'SD',
  'FI',
  'SR',
  'CH',
  'SZ',
  'SY',
  'TJ',
  'TW',
  'TZ',
  'DK',
  'TH',
  'TG',
  'TK',
  'TO',
  'TT',
  'TD',
  'CZ',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'HU',
  'UY',
  'NC',
  'NZ',
  'UZ',
  'BY',
  'VU',
  'VA',
  'VE',
  'RU',
  'VN',
  'EE',
  'WF',
  'US',
  'UM',
  'VI',
  'ZW',
]

export const emptyDog: Dog = {
  regNo: '',
  results: [],
}
export const emptyBreeder: RegistrationBreeder = {
  name: '',
}
export const emptyPerson: RegistrationPerson = {
  email: '',
  location: '',
  membership: false,
  name: '',
  phone: '',
}
